import { Stack, Button, IconButton, Tooltip, TextField, Autocomplete, Box, Typography, FormControlLabel, Switch, Select, FormControl, InputLabel, MenuItem, RadioGroup, Radio } from "@mui/material";
import { useContext, useState, useEffect, ChangeEvent, useCallback, SyntheticEvent, useMemo } from "react";
import styled from 'styled-components';
import Table from '../custom/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IGetBusinessUnitResponse, INV_INVENTORY_SHOWCASE, INV_STO_COLUMN, InventoryData, MyObject, TransactionDetail, logisticOptions } from "../../Models/Inventory";
import Modal from '../Modals';
import useService from '../../hooks/useService';
import { InventoryContext } from "../../contexts/InventoryContext";
import { ShowSerialNumbers, ShowTranscationDetails, getInventoryType } from "./InventoryShowcase";
import { createStockTransferOrder, fetchBusinessUnits, fetchExternalLocations, fetchInventory, fetchStoInventory } from "../../services/Inventory";
import { AuthContext } from "../../contexts/AuthContext";
import { GridColDef, GridRowSelectionModel, GridRowParams, GridRenderCellParams, GridToolbar, DataGrid, GridFilterModel } from '@mui/x-data-grid';
import { Theme } from '@mui/material/styles';
import { IStocktranferData } from "../../services/Inventory/types";
import { NotificationContext } from "../../contexts/NotificationContext";
import { FLOAT_REGEX, WEIGHT_MARGIN } from "../../utils/constant";
import CustomToggle from "../customToggle";

const SerialNumberGrid = styled.div`
  width: 900px !important;
`
const InventoryType: any = {
  1: 'Normal SKU',
  2: 'Cut Bar/Loose Items',
  3: 'Buffing dust',
  4: 'Scrap from barter/buyback',
  5: 'Jobwork Metal',
  6: 'GMS Metal',
  7: 'Non-Serialized SKU'
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const TextFieldGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
`
export const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  padding: 3px 0;
`
export const Typographyfield = styled(Typography)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  padding: 10px;
`
export const TypographyValue = styled(Typography)`
  color: #333E48;
  font-size: 18px !important;
  font-style: normal;
  font-weight: bold !important;
  padding: 10px;
`
const DropdownRow = styled.div`
  width: 800px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
`
const Toggle = styled.div`
  display: flex;
  margin-left: 25px;
`
interface STOModalProps {
  onClose: () => any;
}
interface DestinationId {
  value: string,
  label: string
}

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function getStyles(name: number, personName: readonly number[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const CreateStockModal = ({ onClose }: STOModalProps) => {
  const { user } = useContext(AuthContext)
  const { stoInventories, businessUnits, externalLocation } = useContext(InventoryContext)
  const { notify } = useContext(NotificationContext);
  const { execute } = useService()

  const [destinationID, setDestinationId] = useState<DestinationId>({ value: '', label: '' } as DestinationId)
  const [billingDestinationId, setBillingDestinationId] = useState<DestinationId>({ value: '', label: '' } as DestinationId)
  const [remarks, setRemarks] = useState<string>('')
  const [otherLogisticAgency, setOtherLogisticAgency] = useState<string>('')
  const [AWbNumber, setAWbNumber] = useState<string>('')
  const [refiningChargesPerGram, setRefiningChargesPerGram] = useState<string>('1')
  const [weight, setWeight] = useState<string>('1.000')
  const [noOfLots, setNoOfLots] = useState<string>('1')
  const [meltingChargePerLot, setMeltingChargePerLot] = useState<string>('300')
  const [logisticAgencyName, setLogisticAgencyName] = useState<string>('')
  const [showLogisticAgencyInput, setShowLogisticAgencyInput] = useState(false);

  const [totalGoldFineWeight, setTotalGoldFineWeight] = useState<number>(0)
  const [totalSilverFineWeight, setTotalSilverFineWeight] = useState<number>(0)
  const [totalNetWeightGm, setTotalNetWeightGm] = useState<number>(0)

  const [isGoldSlected, setIsGoldSlected] = useState<boolean>(false)
  const [isSilverSlected, setIsSilverSlected] = useState<boolean>(false)
  const [selectedOutboundMetal, setSelectedOutboundMetal] = useState<string>('')

  const [ownedMetalSelected, setOwnedMetalSelected] = useState<boolean>(false)
  const [nonOwnedMetalSelected, setNonOwnedMetalSelected] = useState<boolean>(false)  //isTaxInvoiceRequired
  const [isTaxInvoiceRequired, setisTaxInvoiceRequired] = useState<boolean>(false)  //isTaxInvoiceRequired
  const [bifurcationMetalType, setBifurcationMetalType] = useState<string>('')

  const [showSerialNumberModal, setShowSerialNumberModal] = useState<boolean | InventoryData>(false)
  const [showTranscationDetail, setShowTranscationDetail] = useState<boolean | TransactionDetail>(false)
  const [selectSerialNumberModal, setSelectSerialNumberModal] = useState<boolean | InventoryData>(false)

  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
  const [rows, setRows] = useState<InventoryData[]>(stoInventories?.data as InventoryData[]);

  const [isTransferOutbound, setIsTransferOutbound] = useState<boolean>(false)
  const [billToSameAsShipTo, setBillToSameAsShipTo] = useState<boolean>(true)

  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 })
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: []
  })

  const isPlantPVC = user?.isPlantPvc!
  let allbusinessUnits: IGetBusinessUnitResponse[] = []

  if(isTransferOutbound) {
    let externalLocationCopy = [...externalLocation]
    allbusinessUnits = externalLocationCopy
  } else {
    let businessUnitsCopy = [...businessUnits]
    allbusinessUnits = businessUnitsCopy
  }

  const isDestinationPlantPVC = allbusinessUnits.find((pvc: any) => pvc.value === destinationID?.value)?.plantPvc

  const clearAllPreviousState = () => {
    setRowSelectionModel([])
    setSelectedOutboundMetal('')
    setIsGoldSlected(false)
    setIsSilverSlected(false)
    clearPreviousRowDetails()
    setRemarks('')
    setNonOwnedMetalSelected(false)
    setOwnedMetalSelected(true)
  }

  const closeTranscationDetailModal = () => {
    setShowTranscationDetail(false)
  }

  const closeSerialNumberModal = () => {
    setShowSerialNumberModal(false)
  }

  const closeSelectSerialNumberModal = () => {
    setSelectSerialNumberModal(false)
  }

  const getTotalFineWeight = (updatedRows: InventoryData[]) => {
    updatedRows.forEach((row: InventoryData) => {
      if(row.metalType.toLowerCase() === 'gold') {
        let total = 0
        let totaMetalWeight = 0
        for(let i = 0; i <= updatedRows.length; i++) {
          let goldFineWeight = updatedRows[i]?.goldFineWeight || 0
          total = total + goldFineWeight
          total = Number(total)
          setTotalGoldFineWeight(total)

          let totalWeight = updatedRows[i]?.transferredWeight || 0
          totaMetalWeight = Number(totaMetalWeight) + Number(totalWeight)
          totaMetalWeight = Number(totaMetalWeight)
          setTotalNetWeightGm(totaMetalWeight)
        }
      } else {
        let total = 0
        let totaMetalWeight = 0
        for(let i = 0; i <= updatedRows.length; i++) {
          let silverFineWeight = updatedRows[i]?.silverFineWeight || 0
          total = total + silverFineWeight
          total = Number(total)
          setTotalSilverFineWeight(total)

          let totalWeight = updatedRows[i]?.transferredWeight || 0
          totaMetalWeight = Number(totaMetalWeight) + Number(totalWeight)
          totaMetalWeight = Number(totaMetalWeight)
          setTotalNetWeightGm(totaMetalWeight)
        }
      }
    })
  }

  const handleQuantityTransfer = (Q: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: InventoryData) => {
    let value = Number(Q?.target?.value) || Number(Q)
    if(value < 0) value = 0

    let updatedRows: InventoryData[] = []
    let transferredWeight = 0
    let fineWeight = 0

    rows.forEach((row: InventoryData) => {
      if(params.id === row.id) {
        let { inventoryType, metalType, quantity, currentWeight, currentFineWeight, serialNumbers } = row

        if(value > quantity) value = quantity

        row['transferredQuantity'] = value

        transferredWeight = (currentWeight / quantity) * value
        row['transferredWeight'] = Number(transferredWeight)

        fineWeight = (currentFineWeight / quantity) * value
        row['fineWeightChange'] = Number(fineWeight)

        // if(inventoryType === 1) {
        //   row['selectedSerialNumbers'] = serialNumbers.slice(0, value)
        //   row['selectedRowIds'] = serialNumbers.slice(0, value).map((vl: number, idx: number) => idx)
        // }

        if(metalType.toLowerCase() === 'gold') {
          row['goldFineWeight'] = fineWeight as number
        } else {
          row['silverFineWeight'] = fineWeight as number
        }
        updatedRows.push(row)
      } else {
        updatedRows.push(row)
      }
    })
    getTotalFineWeight(updatedRows as InventoryData[])
    setRows(updatedRows as InventoryData[])
  }

  const handleWeightTransfer = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: InventoryData) => {
    e.stopPropagation()
    let value = Number(e.target.value)
    if(value < 0) value = 0

    let updatedRows: InventoryData[] = []
    let transferredWeight = 0
    let fineWeight = 0

    rows.forEach((row: InventoryData) => {
      let { id, inventoryType, currentWeight, metalType, purity, currentFineWeight, quantity } = row

      if(params.id === id) {
        if(inventoryType !== 3 && value > Number(currentWeight)) {
          transferredWeight = currentWeight
        } else {
          transferredWeight = value
        }

        fineWeight = (value * Number(purity)) / 1000
        fineWeight = Number(fineWeight)

        if(params.inventoryType === 3) {
          fineWeight = (Number(currentFineWeight) * value) / currentWeight
          fineWeight = Number(fineWeight)
        }

        row['transferredWeight'] = transferredWeight
        row['fineWeightChange'] = fineWeight
        // row['transferredQuantity'] = quantity

        if(metalType.toLowerCase() === 'gold') {
          row['goldFineWeight'] = fineWeight as number
        } else {
          row['silverFineWeight'] = fineWeight as number
        }
        updatedRows.push(row)
      } else {
        updatedRows.push(row)
      }
    })

    getTotalFineWeight(updatedRows as InventoryData[])
    setRows(updatedRows as InventoryData[])
  }

  const handleRemarks = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: GridRenderCellParams) => {
    let value = e.target.value
    setRows((prev: any) => prev.map((row: any) => {
      return params.row.id === row.id ? { ...row, 'remarks': value } : row
    }))
  }

  const getInventoryColumns = () => {
    let minWidth = 300

    let columnToShowCase = (ownedMetalSelected || nonOwnedMetalSelected || isDestinationPlantPVC)
      ? INV_STO_COLUMN
      : INV_INVENTORY_SHOWCASE

    return columnToShowCase.map(inboundField => {

      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: 'left',
        editable: false,
        headerAlign: 'left'
      }

      switch (inboundField.id) {
        case "image":
          row.minWidth = 100;
          row.filterable = false;
          row.renderCell = params => {
            let url = params.row.images.length > 0 ? params.row.images.sort((a: MyObject, b: MyObject) => Number(a.priority) - Number(b.priority))[0].img_url : ''
            return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
          }
          break;
        case "name":
          row.minWidth = 550;
          row.type = 'string';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.name ? params.row.name : "NA"}>
                <Typography>{params.row.name ? params.row.name : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "inventoryType":
          row.minWidth = 220;
          row.type = 'string';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={getInventoryType(params.row)}>
                <Typography>{getInventoryType(params.row)}</Typography>
              </Tooltip>
            )
          }
          break;
        case "skuId":
          row.minWidth = 200;
          row.type = 'string';
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.skuId ? params.row.skuId : "NA"}>
                <Typography>{params.row.skuId ? params.row.skuId : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "currentWeight":
          row.minWidth = 150;
          row.type = 'number';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.currentWeight > 0 ? params.row.currentWeight : 0}>
                <Typography>{params.row.currentWeight > 0 ? params.row.currentWeight : 0}</Typography>
              </Tooltip>
            )
          }
          break;
        case "currentFineWeight":
          row.minWidth = 150;
          row.filterable = false;
          row.type = 'number';
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}>
                <Typography>{params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}</Typography>
              </Tooltip>
            )
          }
          break;
        case "availableStock":
          row.minWidth = 150;
          row.type = 'number';
          row.filterable = false;
          row.renderCell = params => {
            return params.row.availableStock ? params.row.availableStock : "NA"
          }
          break;
        case "dimensions":
          row.minWidth = 100;
          row.type = 'string';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.dimensions ? params.row.dimensions : "NA"}>
                <Typography>{params.row.dimensions ? params.row.dimensions : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "shape":
          row.minWidth = 100;
          row.type = 'string';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.shape ? params.row.shape : "NA"}>
                <Typography>{params.row.shape ? params.row.shape : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "quantity":
          row.minWidth = 100;
          row.type = 'number';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.quantity > 0 ? params.row.quantity : 0}>
                <Typography>{params.row.quantity > 0 ? params.row.quantity : 0}</Typography>
              </Tooltip>
            )
          }
          break;
        case "purity":
          row.minWidth = 100;
          row.type = 'number';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.purity ? params.row.purity : "NA"}>
                <Typography>{params.row.purity ? params.row.purity : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "transactionDetails":
          row.minWidth = 150;
          row.filterable = false;
          row.filterable = false;
          row.renderCell = params => {
            let transactionDetails = params.row.transactionDetails
            return <>{transactionDetails ?
              <Tooltip title='View transaction Details'>
                <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowTranscationDetail(transactionDetails)}><VisibilityIcon /></IconButton>
              </Tooltip> : "NA"
            }</>
          }
          break;
        case "metalType":
          row.minWidth = 100;
          row.type = 'string';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.metalType ? params.row.metalType : "NA"}>
                <Typography>{params.row.metalType ? params.row.metalType : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        case "weight":
          row.minWidth = 180;
          row.type = 'number';
          row.filterable = false;
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.currentWeight ? params.row.currentWeight : 'NA'}>
                <Typography>{params.row.currentWeight ? params.row.currentWeight : 'NA'}</Typography>
              </Tooltip>
            )
          }
          break;
        case "transferredWeight":
          row.minWidth = 200;
          row.type = 'number';
          row.filterable = false;
          row.headerAlign = 'left';
          row.renderCell = params => {
            return<>{
              (params.row.inventoryType !== 1 && params.row.inventoryType !== 7) ?
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={rowSelectionModel.includes(params.row.id) && params.row.transferredWeight !== 0 ? params.row.transferredWeight : ''}
                  onChange={(e) => handleWeightTransfer(e, params.row)}
                  onKeyDown={(e) => e.stopPropagation()}
                  type={'number'}
                  disabled={!rowSelectionModel.includes(params.row.id) || params.row.inventoryType === 4 || params.row.inventoryType === 5 || params.row.inventoryType === 6}
                />
                :
                <TextField
                  disabled
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={rowSelectionModel.includes(params.row.id) && params.row.transferredWeight !== 0 ? params.row.transferredWeight : ''}
                  type={'number'}
                />
            }
            </>
          }
          break;
        case "transferredQuantity":
          row.filterable = false;
          row.minWidth = 200;
          row.type = 'number';
          row.headerAlign = 'left';
          row.renderCell = params => {
            return<>{
              (params.row.inventoryType !== 2 && params.row.inventoryType !== 3 && params.row.inventoryType !== 4 && params.row.inventoryType !== 5 && params.row.inventoryType !== 6) ?
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={rowSelectionModel.includes(params.row.id) && params.row.transferredQuantity !== 0 ? params.row.transferredQuantity : ''}
                  onChange={(e) => handleQuantityTransfer(e, params.row)}
                  type={'number'}
                  disabled={!rowSelectionModel.includes(params.row.id)}
                />
                : "NA"
            }
            </>
          }
          break;
        case "remarks":
          row.filterable = false;
          row.minWidth = 350;
          row.type = 'string';
          row.filterable = false;
          row.renderCell = params => {
            return <TextField
              fullWidth
              size="small"
              variant="outlined"
              value={rowSelectionModel.includes(params.row.id) && params.row.remarks ? params.row.remarks : ''}
              onChange={(e) => handleRemarks(e, params)}
              onKeyDown={(e) => e.stopPropagation()}
              type={'string'}
              disabled={!rowSelectionModel.includes(params.row.id)}
            />
          }
          break;
        case "serialNumbers":
          row.filterable = false;
          row.minWidth = 150;
          row.filterable = false;
          row.renderCell = params => {
            return <>{
              params.row.inventoryType === 1 && rowSelectionModel.includes(params.row.id)
                ? <Tooltip title='Select Serial Numbers'>
                  <IconButton style={{ marginLeft: '-10px' }} onClick={() => setSelectSerialNumberModal(params.row)}><VisibilityIcon /></IconButton>
                </Tooltip>
                : params.row.inventoryType === 1 ?
                  <Tooltip title='View Serial Numbers'>
                    <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowSerialNumberModal(params.row)}><VisibilityIcon /></IconButton>
                  </Tooltip>
                  : "NA"
            }</>
          }
          break;
        case "globalTransactionNumber":
          row.minWidth = 200;
          row.type = 'string';
          row.renderCell = params => {
            return (
              <Tooltip title={params.row.globalTransactionNumber ? params.row.globalTransactionNumber : "NA"}>
                <Typography>{params.row.globalTransactionNumber ? params.row.globalTransactionNumber : "NA"}</Typography>
              </Tooltip>
            )
          }
          break;
        default:
          row.minWidth = 100
          break;
      }
      return row;
    })
  }


  useEffect(() => {
    setIsGoldSlected(false)
    if(isTransferOutbound && stoInventories?.data){
      setIsGoldSlected(true)
      let updatedRows = stoInventories.data
      updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && row.metalType === "gold" && [1, 7].includes(row.inventoryType))
      setRows(updatedRows)
    }
    if(!isTransferOutbound){
      let updatedRows = stoInventories.data
      setRows(updatedRows)
    }
  }, [isTransferOutbound])

  const handleMetalCheck = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
    setSelectedOutboundMetal(type)
    setRowSelectionModel([])
    let updatedRows = stoInventories.data

    if(type === 'gold') {
      setIsGoldSlected(e.target.checked)
      setIsSilverSlected(false)
      setTotalSilverFineWeight(0)
      if(ownedMetalSelected)
        updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && row.metalType === type && [1, 7].includes(row.inventoryType))
      else
      updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && row.metalType === type && [1,5,6,7].includes(row.inventoryType))
    } else {
      setIsSilverSlected(e.target.checked)
      setIsGoldSlected(false)
      setTotalGoldFineWeight(0)
      updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && row.metalType === type && [1, 7].includes(row.inventoryType))
    }
    setRows(updatedRows)
  }

  const handleSelection = () => {
    let updatedRow: InventoryData[] = []

    stoInventories.data.forEach((row: InventoryData) => {
      row['isEditable'] = true
      updatedRow.push(row as InventoryData)

      // if(row.inventoryType === 5) {
      //   if(isPlantPVC) {
      //     row['isEditable'] = true
      //     updatedRow.push(row as InventoryData)
      //   } else {
      //     row['isEditable'] = false
      //     updatedRow.push(row as InventoryData)
      //   }
      // } else {
      //   row['isEditable'] = true
      //   updatedRow.push(row as InventoryData)
      // }
    })
    // setRows(updatedRow.filter((row: InventoryData) => row.quantity > 0))
  };

  const clearPreviousRowDetails = () => {
    let updatedRows: InventoryData[] = []

    rows.forEach((row: InventoryData) => {
      // if(row['goldFineWeight'] && (row.inventoryType === 2 || row.inventoryType === 3)) {
      //   row['currentFineWeight'] = Number(row.currentFineWeight) + Number(row.goldFineWeight)
      // }
      // if(row['silverFineWeight'] && (row.inventoryType === 2 || row.inventoryType === 3)) {
      //   row['currentFineWeight'] = Number(row.currentFineWeight) + Number(row.silverFineWeight)
      // }

      row['silverFineWeight'] = 0
      row['goldFineWeight'] = 0
      row['transferredWeight'] = 0
      row['remarks'] = ''
      row['transferredQuantity'] = 0
      row['fineWeightChange'] = 0
      row['selectedSerialNumbers'] = []
      row['selectedRowIds'] = []
      updatedRows.push(row as InventoryData)
    })
    setRows(updatedRows as InventoryData[])
    setTotalGoldFineWeight(0 as number)
    setTotalSilverFineWeight(0 as number)
    setTotalNetWeightGm(0)
  }

  // const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
  //   if(bifurcationMetalType === 'nonOwned') {
  //     if(rows && rows.length && rows.length > 1 && rows.length === newRowSelectionModel.length) return 
  //     const selectedRowType = rows.find((row: InventoryData) => row.id === newRowSelectionModel[0])?.inventoryType

  //     let updatedRow: InventoryData[] = []
  //     if(newRowSelectionModel && newRowSelectionModel.length && newRowSelectionModel.length > 0) {
  //       if(selectedRowType === 5 || selectedRowType === 6) {
  //         rows.forEach((row: InventoryData) => {
  //           if(newRowSelectionModel.includes(row.id)) {
  //             row['isEditable'] = true
  //             updatedRow.push(row as InventoryData)
  //           } else {
  //             row['isEditable'] = false
  //             updatedRow.push(row as InventoryData)
  //           }
  //         })
  //       } else {
  //         rows.forEach((row: InventoryData) => {
  //           if(row.inventoryType !== 5 && row.inventoryType !== 6) {
  //             row['isEditable'] = true
  //             updatedRow.push(row as InventoryData)
  //           } else {
  //             row['isEditable'] = false
  //             updatedRow.push(row as InventoryData)
  //           }
  //         })
  //       }
  //       setRows(updatedRow)
  //     } else {
  //       rows.forEach((row: InventoryData) => {
  //         row['isEditable'] = true
  //         updatedRow.push(row as InventoryData)
  //       })
  //       reloadStoInventory()
  //     }
  //   }

  //   setRowSelectionModel(newRowSelectionModel)

  //   if(newRowSelectionModel && newRowSelectionModel.length && newRowSelectionModel.length > 0) {
  //     let updatedRow: InventoryData[] = []

  //     rows.forEach((row: InventoryData) => {
  //       if(newRowSelectionModel.includes(row.id)) {
  //         if(row.inventoryType === 4 || row.inventoryType === 5 || row.inventoryType === 6){
  //           row['fineWeightChange'] = row.currentFineWeight
  //           row['transferredWeight'] = row.currentWeight
  //           row['transferredQuantity'] = row.quantity

  //           if(row.metalType.toLowerCase() === 'gold') {
  //             row['goldFineWeight'] = row.currentFineWeight
  //           } else {
  //             row['silverFineWeight'] = row.currentFineWeight
  //           }
  //         }
  //         updatedRow.push(row as InventoryData)
  //       } else {
  //         if(row['goldFineWeight'] && (row.inventoryType === 2 || row.inventoryType === 3)) {
  //           row['currentFineWeight'] = Number(row.currentFineWeight) + Number(row.goldFineWeight)
  //         }

  //         if(row['silverFineWeight'] && (row.inventoryType === 2 || row.inventoryType === 3)) {
  //           row['currentFineWeight'] = Number(row.currentFineWeight) + Number(row.silverFineWeight)
  //         }

  //         delete row['transferredWeight']
  //         delete row['remarks']
  //         delete row['transferredQuantity']
  //         delete row['fineWeightChange']
  //         row['goldFineWeight'] = 0
  //         row['silverFineWeight'] = 0
  //         row['selectedSerialNumbers'] = []
  //         row['selectedRowIds'] = []
  //         updatedRow.push(row as InventoryData)
  //       }
  //     })
  //     getTotalFineWeight(updatedRow)
  //     setRows(updatedRow)
  //   } else {
  //     clearPreviousRowDetails()
  //     reloadStoInventory()
  //   }
  // }

  const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
    // Prevent full selection for nonOwned type
    if (bifurcationMetalType === 'nonOwned') {
      if (rows?.length > 1 && rows.length === newRowSelectionModel.length) return;

      const selectedRowType = rows.find(row => row.id === newRowSelectionModel[0])?.inventoryType;

      let updatedRows: InventoryData[] = [];

      if (newRowSelectionModel?.length) {
        if (selectedRowType === 5 || selectedRowType === 6) {
          rows.forEach(row => {
            row.isEditable = newRowSelectionModel.includes(row.id);
            updatedRows.push({ ...row });
          });
        } else {
          rows.forEach(row => {
            row.isEditable = !(row.inventoryType === 5 || row.inventoryType === 6);
            updatedRows.push({ ...row });
          });
        }
        setRows(updatedRows);
      } else {
        const updated = rows.map(row => ({ ...row, isEditable: true }));
        setRows(updated);
        reloadStoInventory();
      }
    }

    setRowSelectionModel(newRowSelectionModel);
    // persistSelection(newRowSelectionModel);

    // Update rows logic
    if (newRowSelectionModel?.length) {
      const updatedRows: InventoryData[] = [];

      rows.forEach(row => {
        if (newRowSelectionModel.includes(row.id)) {
          if ([4, 5, 6].includes(row.inventoryType)) {
            row.fineWeightChange = row.currentFineWeight;
            row.transferredWeight = row.currentWeight;
            row.transferredQuantity = row.quantity;

            if (row.metalType.toLowerCase() === 'gold') {
              row.goldFineWeight = row.currentFineWeight;
            } else {
              row.silverFineWeight = row.currentFineWeight;
            }
          }
          updatedRows.push({ ...row });
        } else {
          if ((row.inventoryType === 2 || row.inventoryType === 3) && row.goldFineWeight) {
            row.currentFineWeight = Number(row.currentFineWeight) + Number(row.goldFineWeight);
          }
          if ((row.inventoryType === 2 || row.inventoryType === 3) && row.silverFineWeight) {
            row.currentFineWeight = Number(row.currentFineWeight) + Number(row.silverFineWeight);
          }

          delete row.transferredWeight;
          delete row.remarks;
          delete row.transferredQuantity;
          delete row.fineWeightChange;

          row.goldFineWeight = 0;
          row.silverFineWeight = 0;
          row.selectedSerialNumbers = [];
          row.selectedRowIds = [];

          updatedRows.push({ ...row });
        }
      });

      getTotalFineWeight(updatedRows);
      setRows(updatedRows);
    } else {
      clearPreviousRowDetails();
      reloadStoInventory();
    }
  }

  const handleDestinationChange = (e: SyntheticEvent<Element, Event>, v: DestinationId | null) => {
    setDestinationId(v as DestinationId ?? { value: '', label: '' })
    if (billToSameAsShipTo) setBillingDestinationId(v as DestinationId ?? { value: '', label: '' })
    clearAllPreviousState()
  }

  const handleBillingDestinationChange = (e: SyntheticEvent<Element, Event>, v: DestinationId | null) => {
    setBillingDestinationId(v as DestinationId ?? { value: '', label: '' })
  }

  const handleMetalBifurcation = (isChecked: boolean, type: string) => {
    setRowSelectionModel([])
    setBifurcationMetalType(type)
    let updatedRows = stoInventories.data

    if(!isChecked) {
      setBifurcationMetalType('')
      handleSelection()
    }

    if(type === 'owned') {
      setOwnedMetalSelected(isChecked)
      setNonOwnedMetalSelected(false)
      setBifurcationMetalType('owned')
      clearPreviousRowDetails()

      updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && [1, 2, 3, 4, 7]//owned metals
        .includes(row.inventoryType))
      .map((row: InventoryData) => ({... row, isEditable: true }))
    } else {
      setNonOwnedMetalSelected(isChecked)
      setOwnedMetalSelected(false)
      clearPreviousRowDetails()
      setBifurcationMetalType('nonOwned')


      // let isDestinationPlantPVC = allbusinessUnits.find((pvc: any) => pvc.value === destinationID.value)?.plantPvc
      if(isPlantPVC || isDestinationPlantPVC) {
        updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && [1, 5, 6, 7].includes(row.inventoryType))//non owned metaks
      } else {
        updatedRows = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && [1, 5, 6, 7]
          .includes(row.inventoryType))
        .map((row: InventoryData) => ({... row, isEditable: false }))
      }
    }
    setRows(updatedRows)
  }

  const handleOuboundTransfer = (e: { target: { checked: boolean } }) => {
    setIsTransferOutbound(e.target.checked)
    setDestinationId({ value: '', label: '' })
    setBillingDestinationId({ value: '', label: '' })
    clearAllPreviousState()
    setSelectedOutboundMetal('gold')
  }

  const toggleBillToSameAsShipto = (e: { target: { checked: boolean } }) => {
    setBillToSameAsShipTo(e.target.checked)
    e.target.checked ? setBillingDestinationId(destinationID) : setBillingDestinationId({ value: '', label: '' })
  }

  const stockTransferOrder = async () => {
    if(!logisticAgencyName) return notify('Please select Logistic Agency Name!', "error")
    if(!destinationID.value) return notify('Please select Destination to transfer STO!', "error")
    if(!billingDestinationId.value) return notify('Please select Billing Location to transfer STO!', "error")
    if(rowSelectionModel && !rowSelectionModel.length) return notify('Please select Inventory and update values!', "error")


      if(isPlantPVC == true && isTaxInvoiceRequired){
        if(!weight) return notify('Please Enter Weight!', "error")
          if(!meltingChargePerLot) return notify('Please Enter Melting Charge!', "error")
          if(!refiningChargesPerGram) return notify('Please Enter Refining Charges!', "error")
            if(!noOfLots) return notify('Please Enter No. Of Lots!', "error")
    }

    const editedRow = rows.filter((row: InventoryData) => rowSelectionModel.some((id) => id === row.id))

    const isBuffingDust = editedRow.find((row: InventoryData) => row.inventoryType === 3)

    if(isBuffingDust) {
      const transferredWeight = isBuffingDust.transferredWeight ?? 0
      const currentWeight = isBuffingDust.currentWeight
      if(
        Number(transferredWeight) > Number(currentWeight + (currentWeight * WEIGHT_MARGIN / 100)) ||
        Number(transferredWeight) < Number(currentWeight - (currentWeight * WEIGHT_MARGIN / 100))
      ) return notify(`Buffing dust transferred weight should be in between 15% +/- with respect to the current weight!`, "error")
    }
    let formDatalogisticAgencyName = ''
    if(logisticAgencyName == "Other")
      formDatalogisticAgencyName = `${otherLogisticAgency} (Other)`
    else
      formDatalogisticAgencyName = logisticAgencyName


    let payload: IStocktranferData & {billing_destination_id:string} = {
      inventoryLineItems: editedRow,
      awb_number: AWbNumber,
      logistic_agency_name: formDatalogisticAgencyName,
      shipper_id: user.centerId,
      destination_id: destinationID.value,
      total_gold_fine_weight: totalGoldFineWeight,
      total_silver_fine_weight: totalSilverFineWeight,
      bifurcationMetalType,
      isTransferOutbound,
      remarks,
      billing_destination_id: billingDestinationId.value
    }

    if(isPlantPVC == true && isTaxInvoiceRequired){
      payload.meltingChargePerLot = meltingChargePerLot
      payload.weight = weight
      payload.refiningChargePerGm = refiningChargesPerGram
      payload.noOfLots = noOfLots
    }


    if(isTransferOutbound) {
      payload = {
        ...payload,
        metal: selectedOutboundMetal,
        totalNetWeightGm: totalNetWeightGm,
        totalFineWeightGm: selectedOutboundMetal === 'gold' ? totalGoldFineWeight : totalSilverFineWeight
      }
    }


    let { data, error } = await execute(() => createStockTransferOrder(payload as IStocktranferData))

    if(!error) {
      notify('Stock transferred successfully!')
      onClose()
      reloadStoInventory()
    }
  }

  const reloadStoInventory = () => {
    let body = {
      channelId: user.centerId! || '',
      bifurcationtype: selectedOption,
      metaltype: selectedOutboundMetal,
      page: paginationModel.page,
      pageSize: paginationModel.pageSize,
      filterModel: filterModel
    }

    execute(() => fetchStoInventory(body)).then(res => setRows(res.data?.data as InventoryData[]))
  }

  const onFilterChange = useCallback((filterModel: GridFilterModel) => {
    setFilterModel(filterModel)
  }, [])

  useEffect(() => {
    handleSelection()
  },[])

  useEffect(() => {
    execute(() => fetchBusinessUnits({ channelId: user.centerId! }))
    execute(() => fetchExternalLocations({}))
  }, [])

  useEffect(() => {
    if(logisticAgencyName && logisticAgencyName =="Other")
      setShowLogisticAgencyInput(true)
    else
      setShowLogisticAgencyInput(false)
  }, [logisticAgencyName])

  useEffect(() => {
    if(isDestinationPlantPVC && isTransferOutbound) {
      let updatedRows: InventoryData[] = stoInventories.data.filter((row: InventoryData) => row.quantity > 0 && [1, 7].includes(row.inventoryType))
      setRows(updatedRows)
    }
    else {
      handleSelection()
    }
  }, [destinationID.value])

  useEffect(() => {
    if(!ownedMetalSelected && !nonOwnedMetalSelected) setRows(stoInventories.data)
  }, [ownedMetalSelected, nonOwnedMetalSelected])

  let columns = getInventoryColumns()

  useEffect(() => {
    // Call handleMetalBifurcation when the component renders
    if(nonOwnedMetalSelected){
      setNonOwnedMetalSelected(true)
      setisTaxInvoiceRequired(true)
      handleMetalBifurcation(nonOwnedMetalSelected, 'nonOwned');
      setIsGoldSlected(false)
      setIsSilverSlected(false)
    }else{
      handleMetalBifurcation(ownedMetalSelected, 'owned');
      setOwnedMetalSelected(true)
      setisTaxInvoiceRequired(false)
      setisTaxInvoiceRequired(false)
      setIsGoldSlected(false)
      setIsSilverSlected(false)
    }

  }, [nonOwnedMetalSelected]); // Empty dependency array means it runs only on mount (initial render)


  // Empty dependency array means it runs only on mount (initial render)



  // const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>,field : string) => {
  //   let inputValue = e.target.value;
  //   // Check if the input value matches the float regex
  //   if (FLOAT_REGEX.test(inputValue) || inputValue === '') {
  //     setWeight(inputValue); // Update state with the valid string value
  //   }
  // };

  const handleWeightChange = (field: string) => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    let inputValue = e.target.value;

    // Allow deleting (empty input), so handle empty value
    if (inputValue === '') {
      if (field === "weight") setWeight('');
      else if (field === "Refining Charge Per Gram") setRefiningChargesPerGram('');
      else if (field === "No. Of Lots") setNoOfLots('');
      else if (field === "Melting Charge Per Lot") setMeltingChargePerLot('');
      return;
    }

    // Check if input matches the float regex (allow decimal numbers)
    if (FLOAT_REGEX.test(inputValue)) {
      if (field === "weight") setWeight(inputValue);
      else if (field === "Refining Charge Per Gram") setRefiningChargesPerGram(inputValue);
      else if (field === "No. Of Lots") setNoOfLots(inputValue);
      else if (field === "Melting Charge Per Lot") setMeltingChargePerLot(inputValue);
    }
  };


  // State to store the selected value
  const [selectedOption, setSelectedOption] = useState("owned");

  // Options for the toggle buttons
  const owned = { value: "owned", label: "Owned Metal" };
  const nonOwned = { value: "nonOwned", label: "Non-Owned Metal" };

  // Function to handle changes when a new option is selected
  const handleToggleChange = (newSelectedValue : any) => {
    setSelectedOption(newSelectedValue); // Update the selected option in the state
  };


  useEffect(() => {
    if(selectedOption == "owned"){
      setOwnedMetalSelected(true)
      setNonOwnedMetalSelected(false)
    }else if(selectedOption == "nonOwned"){
      setNonOwnedMetalSelected(true)
      setOwnedMetalSelected(false)
    }
  }, [selectedOption])

  useEffect(() => {
    reloadStoInventory()
  }, [paginationModel, filterModel.items[0]?.value, selectedOption, selectedOutboundMetal])

  return (
    <Container style={{padding: '10px'}}>
      <Stack width="100%" direction="row">
        <Toggle style={{ marginLeft:"0px" }}>
          <FormControlLabel
            control={
              <Switch color="primary" checked={isTransferOutbound} onChange={handleOuboundTransfer} />
            }
            label={"Transfer Outbound"}
          />
        </Toggle>
        {(isDestinationPlantPVC || isTransferOutbound) &&
            <RadioGroup row style={{ marginLeft: '20px' }}>
              <FormControlLabel
                control={<Radio checked={isGoldSlected} value="gold" onChange={e => handleMetalCheck(e, 'gold')} />}
                label={"GOLD"}
              />
              <FormControlLabel
                control={<Radio checked={isSilverSlected} value="silver" onChange={e => handleMetalCheck(e, 'silver')} />}
                label={"SILVER"}
              />
            </RadioGroup>
          }
        {isPlantPVC && nonOwnedMetalSelected && isTaxInvoiceRequired ?
          <Toggle style={{ marginLeft: "0px" }}>
            <FormControlLabel
              control={
                <Switch color="primary" checked={billToSameAsShipTo} onChange={toggleBillToSameAsShipto} />
              }
              label={"Billing Location same as Destination"}
            />
          </Toggle> :
          <></>}
      </Stack>
      <Stack width="100%" direction="row" gap="25px" align-items="center" marginTop="15px">
        <DropdownRow>
          <Autocomplete
            disablePortal
            defaultValue={destinationID}
            value={destinationID}
            id="combo-box-demo"
            options={allbusinessUnits}
            onChange={(e, v) => handleDestinationChange(e, v)}
            sx={{ width: '100%' }}
            renderInput={(params) => (
              <TextField {...params} label="Search Destination" size="medium" />
            )}
          />

          {
            billToSameAsShipTo ?
              <></> :
              <div style={{ paddingLeft: '20px', width: '100%' }}>
                <Autocomplete
                  disablePortal
                  defaultValue={billingDestinationId}
                  value={billingDestinationId}
                  id="combo-box-demo2"
                  options={allbusinessUnits}
                  onChange={(e, v) => handleBillingDestinationChange(e, v)}
                  sx={{ width: '100%' }}
                  renderInput={(params) => (
                    <TextField {...params} label="Billing To Location" size="medium" />
                  )}
                />
              </div>
          }
        </DropdownRow>

          

        <TextField
          label="AWB Number"
          value={AWbNumber}
          variant="outlined"
          onChange={(e) => setAWbNumber(e.target.value)}
          sx={{ width: 800, marginBottom: '25px' }}
        />
      </Stack>

      {(isDestinationPlantPVC && isTransferOutbound)
        ? <></>
        :<Stack width="100%" direction="row" gap="25px" marginBottom="5px">
          <CustomToggle
            selected={selectedOption} // Pass the current selected value
            optionOne={owned} // Pass the first option
            optionTwo={nonOwned} // Pass the second option
            onChange={handleToggleChange} // Pass the change handler function
          />
          <Toggle style={{ marginLeft:"0px" }}>
            {/* <FormControlLabel
              control={
                <Switch color="primary" checked={ownedMetalSelected} onChange={(e) => handleMetalBifurcation(e.target.checked as true, 'owned')} />
              }
              label={"Owned Metal"}
              disabled={destinationID.value === ''}
              required
            /> */}
            {/* <Typography style={{ padding: '12px',paddingLeft : "0px" }}>Owned Metal</Typography>
            <FormControlLabel
              control={
                <Switch color="primary" checked={nonOwnedMetalSelected} onChange={(e) =>  handleMetalBifurcation(e.target.checked as true, 'nonOwned')} style={{color : '#cfa04f'}} />
              }
              label={"Non-owned Metal"}
              disabled={destinationID.value === ''}
              required
            /> */}
            {nonOwnedMetalSelected && isPlantPVC == true ?  <FormControlLabel
              control={
                <Switch color="primary" checked={isTaxInvoiceRequired} onChange={(e) =>  setisTaxInvoiceRequired(e.target.checked as true)} />
              }
              label={"With Service Tax Invoice"}
              required
            /> : <></>}
          </Toggle>
        </Stack>
      }
      <Typography variant="caption" display="block" marginBottom="25px">
        {'Note: Non-Owned metals are allowed to sent to Plant PVC only.'}
      </Typography>


      {isTaxInvoiceRequired && isPlantPVC == true ?   <Stack width="100%" direction="row" gap="25px" align-items="center" marginTop="15px">
        <TextField
          label="No. Of Lots"
          value={noOfLots}
          variant="outlined"
          onChange={handleWeightChange('No. Of Lots')}
          sx={{ width: 800, marginBottom: '25px' }}
        />
        <TextField
          label="Refining Charge Per Gram"
          value={refiningChargesPerGram} //refiningChargePerGm
          variant="outlined"
          onChange={handleWeightChange('Refining Charge Per Gram')}
          sx={{ width: 800, marginBottom: '25px' }}
        />
        <TextField
          label="Weight Before Melting" // Need to confirm
          value={weight}
          variant="outlined"
          onChange={handleWeightChange('weight')}
          sx={{ width: 800, marginBottom: '25px' }}
          InputProps={{
            inputMode: 'decimal',  // Specifies the input is a decimal number
          }}
        />
        <TextField
          label="Melting Charge Per Lot"
          value={meltingChargePerLot}
          variant="outlined"
          onChange={handleWeightChange('Melting Charge Per Lot')}
          sx={{ width: 800, marginBottom: '25px' }}
        />
      </Stack> : <></> }

      <Table
        fixHeight={500}
        editMode="row"
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rows={rows || []}
        getRowId={(row) => row.id}
        columns={columns}
        checkboxSelection={(isDestinationPlantPVC && isTransferOutbound) || (ownedMetalSelected || nonOwnedMetalSelected)}
        disableRowSelectionOnClick
        isRowSelectable={(params: GridRowParams) => (isDestinationPlantPVC && isTransferOutbound) ? params.row.metalType === selectedOutboundMetal : params.row.isEditable}
        onRowSelectionModelChange={handleRowSelectionModel}
        rowSelectionModel={rowSelectionModel}
        paginationMode={"server"}
        hideFooter={false} 
        rowCount={stoInventories?.count ?? 0}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          panel: {
            sx: {
              '& .MuiDataGrid-filterForm': {
                flexDirection: 'row',
              },
              '& .MuiDataGrid-filterFormValueInput': {
                minWidth: '1150px',
              },
            },
          },
        }}
        pageSizeOptions={[25, 50, 75, 100, 150]}
        filterMode='server'
        filterDebounceMs={300}
        onFilterModelChange={onFilterChange}
      />

      <Stack width="100%" direction="row" gap="25px" align-items="center">
        <Box sx={{ marginTop: '25px' }}>
          <FormControl required fullWidth size='medium'>
            <InputLabel id={`logistic_gency_name`}>Logistic Agency Name</InputLabel>
            <Select
              required
              labelId={`logistic_gency_name`}
              label='Logistic Agency Name'
              value={logisticAgencyName}
              onChange={(e) => setLogisticAgencyName(e.target.value)}
              sx={{ width: 400 }}
            >
              {logisticOptions?.map((option, index) => {
                return <MenuItem  key={index} value={option.value}>{option.label}</MenuItem>
              })}
            </Select>
          </FormControl>
        </Box>
        {showLogisticAgencyInput ?  <TextField
          required
          fullWidth
          label="Enter Logistic Agency Name"
          rows={1}
          value={otherLogisticAgency}
          variant="outlined"
          onChange={(e) => setOtherLogisticAgency(e.target.value)}
          sx={{ marginTop: '25px' }}
        />:<></> }
        <TextField
          required
          fullWidth
          label="Remarks"
          multiline
          rows={1}
          value={remarks}
          variant="outlined"
          onChange={(e) => setRemarks(e.target.value)}
          sx={{ marginTop: '25px' }}
        />
      </Stack>

      <TextFieldGroup>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '500px' }}>
          <Typographyfield>{'Total Gold fine Weight'}</Typographyfield> :
          <TypographyValue>{totalGoldFineWeight.toFixed(3)} gm</TypographyValue>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', width: '500px' }}>
          <Typographyfield>{'Total Silver Fine Weight'}</Typographyfield> :
          <TypographyValue>{totalSilverFineWeight.toFixed(3)} gm</TypographyValue>
        </Box>
      </TextFieldGroup>

      <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
        <Button onClick={onClose}>Cancel</Button>
        <Button color="primary" variant="contained" onClick={stockTransferOrder} disabled={!destinationID || !remarks || (!logisticAgencyName && !otherLogisticAgency)}>Submit</Button>
      </Stack>
      <Modal open={typeof showTranscationDetail != 'boolean'} title={'View Transcation Details'} onClose={closeTranscationDetailModal} maxWidth={'xl'}>
        <ShowTranscationDetails data={showTranscationDetail} />
      </Modal>
      <Modal open={typeof showSerialNumberModal != 'boolean'} title={'view Serial Numbers'} onClose={closeSerialNumberModal} maxWidth={'xl'}>
        <ShowSerialNumbers data={showSerialNumberModal}  />
      </Modal>
      <Modal open={typeof selectSerialNumberModal != 'boolean'} title={'Select Serial Numbers'} onClose={closeSelectSerialNumberModal} maxWidth={'xl'}>
        <ShowMetalSerialNumbers currentRow={selectSerialNumberModal} allRows={rows} setUpdatedRow={setRows} handleQuantity={handleQuantityTransfer} />
      </Modal>
    </Container>
  )
}

export default CreateStockModal



export function ShowMetalSerialNumbers({ currentRow, allRows, setUpdatedRow, handleQuantity }: { currentRow: InventoryData | boolean, allRows: InventoryData[], setUpdatedRow: Function, handleQuantity: Function }) {
  let { id, skuId, name, currentWeight, quantity, metalType, serialNumbers } = currentRow as InventoryData

  const [serialNumberRows, setSerialNumberRows] = useState([])
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  useEffect(() => {
    let updatedRows = JSON.parse(serialNumbers).map((item: any, idx: any) => {
      return {
        id: idx,
        skuId: skuId,
        name: name,
        currentWeight: Number((currentWeight / quantity).toFixed(3)),
        metalType: metalType,
        serialNumber: item
      }
    })
    setSerialNumberRows(updatedRows as any)

    let currentSelectedRow = allRows.find((row: InventoryData) => row.id === id)
    setRowSelectionModel(currentSelectedRow?.selectedRowIds as GridRowSelectionModel)
  }, [])

  const handleRowSelection = (rowSelectId: GridRowSelectionModel) => {
    let selectedSerialNumbers: number[] = []
    const selectedIDs = new Set(rowSelectId);

    serialNumberRows.filter((row: any) => selectedIDs.has(row.id))
      .map((row: any) => selectedSerialNumbers.push(row.serialNumber))
    let totalSerialNumbers = selectedSerialNumbers.length

    setUpdatedRow((prev: InventoryData[]) => {
      let previousRows = [...prev]
      let idx = previousRows.findIndex((row: InventoryData) => row.id ===  id)
      previousRows[idx].selectedSerialNumbers = selectedSerialNumbers
      previousRows[idx].selectedRowIds = rowSelectId as number[]
      handleQuantity(totalSerialNumbers, currentRow)
      return previousRows
    })
    setRowSelectionModel(rowSelectId)
  }

  let columns: GridColDef[] = [
    {
      field: "skuId",
      headerName: "SKU ID",
      minWidth: 180,
      renderCell: (params: any) => {
        return params.row.skuId
      }
    },
    {
      field: "name",
      headerName: "SKU Name",
      minWidth: 250,
      renderCell: (params: any) => {
        return params.row.name
      }
    },
    {
      field: "currentWeight",
      headerName: "Unit Weight (gm)",
      minWidth: 150,
      renderCell: (params: any) => {
        return params.row.currentWeight
      }
    },
    {
      field: "metalType",
      headerName: "Metal Type",
      minWidth: 150,
      renderCell: (params: any) => {
        return params.row.metalType
      }
    },
    {
      field: "serialNumber",
      headerName: "Serial Number",
      minWidth: 120,
      renderCell: (params: any) => {
        return params.row.serialNumber
      }
    },
  ]

  return (
    <SerialNumberGrid>
      <DataGrid
        getRowId={(row) => row.id}
        rows={serialNumberRows}
        columns={columns}
        pagination={true}
        paginationMode={"client"}
        rowHeight={40}
        checkboxSelection
        onRowSelectionModelChange={handleRowSelection}
        rowSelectionModel={rowSelectionModel}
        slots={{toolbar: GridToolbar}} 
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        sx={{
          ".MuiDataGrid-columnHeaders":
          {
            background: 'var(--primary_color_light)',
            borderRadius: '0'
          },
          border: 'none',
          borderRadius: '0'
        }}
      />
    </SerialNumberGrid>
  )
}